"use strict";
// THIS CODE WAS AUTOMATICALLY GENERATED
// DO NOT EDIT THIS CODE BY HAND
// RUN THE FOLLOWING COMMAND FROM THE WORKSPACE ROOT TO REGENERATE:
// npx nx generate-lib repo
Object.defineProperty(exports, "__esModule", { value: true });
exports.es2022_sharedmemory = void 0;
const base_config_1 = require("./base-config");
exports.es2022_sharedmemory = {
    Atomics: base_config_1.TYPE,
};
//# sourceMappingURL=es2022.sharedmemory.js.map